<template>
    <div ref="paymentmodal" class="payment-modal background-image fixed z-30 top-0 left-0 w-full h-screen hidden overflow-y-auto">
        <div class="modal-container w-full h-screen z-50  absolute top-0 right-0 flex items-center justify-center">
            <div class="modal-close absolute top-0 right-0 mr-5 mt-5 md:mt-32 md:mr-10 cursor-pointer flex flex-col items-center mr-4 text-white">
                <img src="/images/large-cross.png" style="width: 32px; height: 32px" @click="toggleModal">
            </div>

            <div class="modal-content w-full px-5 lg:p-0 md:w-1/2 lg:w-1/4 self-center overflow-y-auto h-screen md:h-auto">
                <div class="flex justify-end items-center pb-3">

                </div>

                <div id="paymentModal" class="py-5" :showModal="payModalActive" v-on:showpayinfo="getPaymentModal">
                    <div>
                        <form enctype="multipart/form-data" id="payModal" action="/payment" method="POST" @submit.prevent="SubmitIfAgreed">
                            <div v-html="payModal_html"></div>
                            <div class="flex flex-row justify-start mt-2 sm:mt-4 items-center w-full">
                                <div class="flex flex-shrink mt-2 mr-2">
                                    <input class="form-checkbox h-5 w-5 transition duration-150 ease-in-out" type="checkbox" id="agreement" name="agreement" value="1" v-model="hasAgreed">
                                </div>

                                <div class="flex w-full justify-center mt-4 sm:mt-0 sm:w-auto">
                                    <span style="color: #fff !important;">Jag godkänner <a href="/integrity_policy" target="_blank" class="underline">användarvillkoren</a>, avbokningsreglerna samt <a href="/integrity_policy" target="_blank" class="underline">integritetspolicyn</a></span>
                                </div>
                            </div>

                            <div v-if="company.id == 48" class="mt-2">
                                <coupon-info :coupons="coupons" :show-warning="company.id == 48"></coupon-info>
                            </div>

                            <div v-if="company.id != 48 || (company.id == 48 && coupons.length > 0)" class="flex-1 py-2 mb-5">
                                <button class="btn text-white rounded px-8 py-2 pull-right mt-4 cursor" :class="hasAgreed ? 'bg-tlmblue2 cursor-pointer' : 'bg-gray-500 cursor-default'" :disabled="!canBook && !loading">Boka <i class="fa fa-check" v-if="!loading"></i><i class="fa fa-spinner fa-spin" v-else></i></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
import Modal from 'modal-vue';
import CouponInfo from "./Booking/CouponInfo";

export default {
    name: "payment",
    props: ["user_id", "coupons", "company"],
    components: {CouponInfo, Modal},
    data() {
        return {
            reservations: null,
            payModal_html: null,
            hasAgreed: false,
            payModalActive: false,
            canBook: false,
            loading: false
        }
    },
    methods: {
        benifyCheck() {
            axios.get('/benifycheck/' + this.user_id)
                .then(response => {
                    if (response.data) {
                        this.canBook = true;
                    }
                })
        },
        toggleModal() {
            const body = document.querySelector('body');
            const modal = this.$refs["paymentmodal"];
            modal.classList.toggle('hidden');
        },
        listen() {
            if (this.user_id != undefined && this.user_id != null && this.user_id != "") {
                Echo.private('receipt.' + this.user_id)
                    .listen("PaymentDone", (e) => {
                        this.getReceipt();
                    });
            }
        },
        getReceipt() {
            axios.get('/payments')
                .then(response => {
                    if (response.data.length != 0) {
                        this.reservations = response.data;
                    }
                })
        },
        SubmitIfAgreed(e) {
            e.preventDefault();
            if (this.hasAgreed && !this.loading) {
                this.loading = true;
                document.getElementById("payModal").submit();
            }
        },
        getPaymentModal() {
            return axios.get('/reservations/book/modal')
                .then((response) => {
                    if (response.data.show_modal) {
                        this.toggleModal();
                        this.payModal_html = response.data.modal_html;

                        this.payModalActive = true;

                    } else {
                        this.$emit('showLoginOrRegisterModal');
                    }
                });
        },
        closePayModalBox(e = null) {
            if (e) e.preventDefault();
            this.toggleModal();
        },
        submitPayModal(e = null) {
            e.preventDefault();
            if (!this.canBook) {
                return;
            }
            let formData = new FormData(e.target);

            axios({
                method: 'post',
                url: '/payment',
                data: formData,
                contentType: false,
                processData: false
            }).then((response) => {
                this.payModal_html = response.data.modal_html;
                if (response.data() == "ok")
                    this.closePayModalBox();
            });
        },
        dateFormat: function (reservation) {
            return moment(reservation.schedules[0].start).format("YY-MM-DD") + " " + moment(reservation.schedules[0].start).format("HH:mm") + " - " + moment(reservation.schedules[0].end).format("HH:mm");
        },
    },
    watch: {
        hasAgreed: {
            deep: true,
            handler(newVal, old) {
            }
        }
    },
    computed: {},
    mounted() {
        let self = this;
        this.listen();
        this.$eventHub.$on('showpayinfo', function () {
            self.getPaymentModal();
        });
        this.benifyCheck();
    }
}
</script>
<style scoped>
h4, span, div {
    color: black;
}

.back-btn {
    position: absolute;
    margin-top: -37px;
    margin-left: 82px;
}
</style>
